<script setup>
import { ref } from "vue";
import { Head, router } from "@inertiajs/vue3";

import Datatables from "@/Shared/Tables/Datatables.vue";
import DatatableFooterWrapper from "@/Shared/Tables/DatatableFooterWrapper.vue";

import VAlert from "@/Shared/VAlert.vue";
import VModalDetail from "./_partials/VModalDetail.vue";

import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import Swal from "sweetalert2";
import axios from "axios";

let props = defineProps({
    title: String,
    additional: Object,
});

const { urlStore, listTab } = props.additional;

const isShowAlert = ref(true);
const isShowForm = ref(false);
const isShowDetail = ref(false);
const isShowApproveForm = ref(false);

const selectedItem = ref(null);

const urlSubmit = ref(urlStore);
const urlSendOtp = ref("");

const formType = ref("create");
const modalFormTitle = ref("Add New Document");

const breadcrumbs = [
    {
        url: "#",
        label: "Documents",
    },
];

const changePageLength = (value) => {
    getList({ per_page: value });
};

const onFilter = (value) => {
    getList({
        search_fields: value.search_fields,
        search_values: value.search_values,
        per_page: props.additional.filters.per_page ?? 20,
        order_by: value.order_by,
        order_type: value.order_type,
    });
};

const getList = (params) => {
    router.get(props.additional.urlIndex, params, {
        preserveState: true,
        replace: true,
    });
};

const removeAction = async (value) => {
    const result = await Swal.fire({
        icon: "warning",
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
    });

    if (!result.isConfirmed) {
        return false;
    }

    router.post(value.url, { _method: "DELETE" });
};

const editAction = async (value) => {
    const response = await axios.get(value.url);

    selectedItem.value = response.data.data;

    urlSubmit.value = value.url;

    formType.value = "edit";
    modalFormTitle.value = "Edit Document";
    isShowForm.value = true;
    isShowAlert.value = false;
};

const showAction = async (value) => {
    const response = await axios.get(value.url);

    selectedItem.value = response.data.data;

    isShowDetail.value = true;
    isShowAlert.value = false;
};

const sendAction = async (value) => {
    const result = await Swal.fire({
        icon: "warning",
        title: "Are you sure?",
        text: "You will send this document!",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Send it!",
    });

    if (!result.isConfirmed) {
        return false;
    }

    router.post(value.url);
};

const syncTransactionAction = async (value) => {
    const response = await axios.post(value.url);

    const result = await Swal.fire({
        icon: "info",
        title: "Sync Transaction Success!",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Okay!",
    });

    router.reload();
};

const actionClick = (value) => {
    console.log(value);
    if (value.type == "delete") {
        removeAction(value);
    }

    if (value.type == "edit") {
        editAction(value);
    }

    if (value.type == "show") {
        showAction(value);
    }

    if (value.type == "send") {
        sendAction(value);
    }

    if (value.type == "check-status") {
        syncTransactionAction(value);
    }
};

const closeDetail = () => {
    selectedItem.value = null;
    isShowDetail.value = false;
    isShowAlert.value = false;
};

const onSave = () => {
    selectedItem.value = null;
    isShowDetail.value = false;
    isShowAlert.value = false;
};
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <VAlert v-if="!isShowForm && isShowAlert" />

        <div class="card">
            <div class="card-body">
                <div class="dataTables_wrapper dt-bootstrap5">
                    <Datatables
                        :columns="additional.columns"
                        :pagination="additional.list"
                        :filters="additional.filters"
                        @onFilter="onFilter"
                        @onActionClick="actionClick"
                    />

                    <DatatableFooterWrapper
                        :pagination="additional.list.meta"
                        :filters="additional.filters"
                        @onChange="changePageLength"
                    />
                </div>
            </div>
        </div>

        <VModalDetail
            v-if="isShowDetail"
            :item="selectedItem"
            title="Attachment"
            descriptionLabel="Attachment"
            :isShowApproval="true"
            @onCancel="closeDetail"
            @onSave="onSave"
        />
    </div>
</template>
